///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = {
    /**
     * Generate the embed iframe html for the specified embed token and url
     *
     * @param {*} embedToken
     * @param {*} embedUrl
     * @returns
     */
    getGeneratedPageURL: function(embedToken, embedUrl) {
        const url = parent.window.location.href;

        return "<html>\n" +
            "   <body>\n" +
            "        <form id=\"form\" action=\"" + embedUrl + "\" method=\"post\">\n" +
            "        <input type=\"hidden\" name=\"embedToken\" value=\"" + embedToken + "\">\n" +
            "        </form>\n" +
            "        <script>\n" +
            "        document.getElementById(\"form\").submit();\n" +
                    // Push history forward with an extra param to force reload if the user hits the back button
            "        parent.window.history.pushState('forward', null, '" + url + "?loaded=true');\n" +
            "        </script>\n" +
            "    </body>\n" +
            "</html>\n";
    },
}
